// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

/* eslint-disable */
import Animations__ParallexController from "./animations/parallax_controller"
application.register("animations--parallax", Animations__ParallexController)

import Enrollments__FormController from "./enrollments/form_controller"
application.register("enrollments--form", Enrollments__FormController)

import Enrollments__FinancementModeController from "./enrollments/financement_mode_controller"
application.register("enrollments--financement-mode", Enrollments__FinancementModeController)

import Enrollments__NestedPaymentInstallmentsController from "./enrollments/nested_form_payment_installments_controller"
application.register("enrollments--nested-form-payment-installments", Enrollments__NestedPaymentInstallmentsController)

import Enrollments__NestedFormFinancementModesController from "./enrollments/nested_form_financement_modes_controller"
application.register("enrollments--nested-form-financement-modes", Enrollments__NestedFormFinancementModesController)

import FaqLists__NestedFormFaqListItemsController from "./faq_lists/nested_form_faq_list_items_controller"
application.register("faq-lists--nested-form-faq-list-items", FaqLists__NestedFormFaqListItemsController)

import TodoLists__DueDateGroupController from "./todo_lists/due_date_group_controller"
application.register("todo-lists--due-date-group", TodoLists__DueDateGroupController)

import TodoLists__ItemController from "./todo_lists/item_controller"
application.register("todo-lists--item", TodoLists__ItemController)

import TodoLists__ItemGroupController from "./todo_lists/item_group_controller"
application.register("todo-lists--item-group", TodoLists__ItemGroupController)

import TrainingSessions__CcConfirmController from "./training_sessions/cc_confirm_controller"
application.register("training-sessions--cc-confirm", TrainingSessions__CcConfirmController)

import TrainingSessions__NewController from "./training_sessions/form_controller"
application.register("training-sessions--form", TrainingSessions__NewController)

import TrainingSessions__NestedFormTrainingSessionDaysController from "./training_sessions/nested_form_training_session_days_controller"
application.register("training-sessions--nested-form-training-session-days", TrainingSessions__NestedFormTrainingSessionDaysController)

import TrainingSessions__TableController from "./training_sessions/table_controller"
application.register("training-sessions--table", TrainingSessions__TableController)

import Trainings__FiltersController from "./trainings/filters_controller"
application.register("trainings--filters", Trainings__FiltersController)

import Trainings__FormController from "./trainings/form_controller"
application.register("trainings--form", Trainings__FormController)

import Trainings__NestedFormTrainingSessionDayTemplatesController from "./trainings/nested_form_training_session_day_templates_controller"
application.register("trainings--nested-form-training-session-day-templates", Trainings__NestedFormTrainingSessionDayTemplatesController)

import Posts__NestedFormContentBlocksController from "./posts/nested_form_content_blocks_controller"
application.register("posts--nested-form-content-blocks", Posts__NestedFormContentBlocksController)

import Posts__SectionableController from "./posts/sectionable_controller"
application.register("posts--sectionable", Posts__SectionableController)

import Posts__TrainingLinkTrackingController from "./posts/training_link_tracking_controller"
application.register("posts--training-link-tracking", Posts__TrainingLinkTrackingController)

import Seo__PreviewController from "./seo/preview_controller"
application.register("seo--preview", Seo__PreviewController)

import Trainings__ReviewsListController from "./trainings/reviews_list_controller"
application.register("trainings--reviews-list", Trainings__ReviewsListController)

import Trainings__InstagramReelModalController from "./trainings/instagram_reel_modal_controller"
application.register("trainings--instagram-reel-modal", Trainings__InstagramReelModalController)

import ZoneByAddressController from "./zone_by_address_controller"
application.register("zone-by-address", ZoneByAddressController)

import ActionInsideFormController from "./action_inside_form_controller"
application.register("action-inside-form", ActionInsideFormController)

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AppliedFiltersSubmitController from "./applied_filters_submit_controller"
application.register("applied-filters-submit", AppliedFiltersSubmitController)

import CheckBoxCardListController from "./check_box_card_list_controller"
application.register("check-box-card-list", CheckBoxCardListController)

import CopyAddressFieldsController from "./copy_address_fields_controller"
application.register("copy-address-fields", CopyAddressFieldsController)

import FindOrCreateUserModeController from "./find_or_create_user_mode_controller"
application.register("find-or-create-user-mode", FindOrCreateUserModeController)

import DestroySingleNestedResourceController from "./destroy_single_nested_resource_controller"
application.register("destroy-single-nested-resource", DestroySingleNestedResourceController)

import EditableSelectController from "./editable_select_controller"
application.register("editable-select", EditableSelectController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import ConnectionHeartbeatController from "./connection_heartbeat_controller"
application.register("connection-heartbeat", ConnectionHeartbeatController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)


import Form__AcceptanceController from "./form/acceptance_controller"
application.register("form--acceptance", Form__AcceptanceController)

import Form__ActivationChecklistController from "./form/activation_checklist_controller"
application.register("form--activation-checklist", Form__ActivationChecklistController)

import Form__AvatarPreviewController from "./form/avatar_preview_controller"
application.register("form--avatar-preview", Form__AvatarPreviewController)

import Form__EmailEditorController from "./form/email_editor_controller"
application.register("form--email-editor", Form__EmailEditorController)

import Form__ConditionController from "./form/condition_controller"
application.register("form--condition", Form__ConditionController)

import Form__CompanyCountryController from "./form/company_country_controller"
application.register("form--company-country", Form__CompanyCountryController)

import Form__CompanyLookupController from "./form/company_lookup_controller"
application.register("form--company-lookup", Form__CompanyLookupController)

import Form__SiretSuggestionsController from "./form/siret_suggestions_controller"
application.register("form--siret-suggestions", Form__SiretSuggestionsController)

import Form__ExistingUserCheckController from "./form/existing_user_check_controller"
application.register("form--existing-user-check", Form__ExistingUserCheckController)

import Form__FileInputController from "./form/file_input_controller"
application.register("form--file-input", Form__FileInputController)

import Form__PhoneCountryController from "./form/phone_country_controller"
application.register("form--phone-country", Form__PhoneCountryController)

import Form__PhoneFormatController from "./form/phone_format_controller"
application.register("form--phone-format", Form__PhoneFormatController)

import Form__DigitCounterController from "./form/digit_counter_controller"
application.register("form--digit-counter", Form__DigitCounterController)

import Form__LengthCounterController from "./form/length_counter_controller"
application.register("form--length-counter", Form__LengthCounterController)

import Form__PhosphorIconController from "./form/phosphor_icon_controller"
application.register("form--phosphor-icon", Form__PhosphorIconController)

import Form__DoctolibImportController from "./form/doctolib_import_controller"
application.register("form--doctolib-import", Form__DoctolibImportController)

import Form__DoctolibUrlController from "./form/doctolib_url_controller"
application.register("form--doctolib-url", Form__DoctolibUrlController)

import Form__EntryFeeNoticeController from "./form/entry_fee_notice_controller"
application.register("form--entry-fee-notice", Form__EntryFeeNoticeController)

import Form__GreetingNameController from "./form/greeting_name_controller"
application.register("form--greeting-name", Form__GreetingNameController)

import Form__RecapController from "./form/recap_controller"
application.register("form--recap", Form__RecapController)

import Form__RevealController from "./form/reveal_controller"
application.register("form--reveal", Form__RevealController)

import Form__SectionCardController from "./form/section_card_controller"
application.register("form--section-card", Form__SectionCardController)

import Form__SectionNavController from "./form/section_nav_controller"
application.register("form--section-nav", Form__SectionNavController)

import Form__AnchorNavController from "./form/anchor_nav_controller"
application.register("form--anchor-nav", Form__AnchorNavController)

import Form__SectionTitleController from "./form/section_title_controller"
application.register("form--section-title", Form__SectionTitleController)

import Form__TrainingPreferencesController from "./form/training_preferences_controller"
application.register("form--training-preferences", Form__TrainingPreferencesController)

import KpiChartController from "./kpi_chart_controller"
application.register("kpi-chart", KpiChartController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import Modal__NavigationController from "./modal/navigation_controller"
application.register("modal--navigation", Modal__NavigationController)

import Modal__AnchorController from "./modal/anchor_controller"
application.register("modal--anchor", Modal__AnchorController)

import Modal__OnDemandController from "./modal/on_demand_controller"
application.register("modal--on-demand", Modal__OnDemandController)

import TurboSubmitButtonController from "./turbo_submit_button_controller"
application.register("turbo-submit-button", TurboSubmitButtonController)

import TurboSubmitRowController from "./turbo_submit_row_controller"
application.register("turbo-submit-row", TurboSubmitRowController)

import TableRowExpandableController from "./table_row_expandable_controller"
application.register("table-row-expandable", TableRowExpandableController)

import SessionOpeningController from "./session_opening_controller"
application.register("session-opening", SessionOpeningController)

import SignaturePadController from "./signature_pad_controller"
application.register("signature-pad", SignaturePadController)

import SessionRecurrenceController from "./session_recurrence_controller"
application.register("session-recurrence", SessionRecurrenceController)

import TextareaAutogrowController from "./textarea_autogrow_controller"
application.register("textarea-autogrow", TextareaAutogrowController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import Company__SiteSwitcherController from "./company/site_switcher_controller"
application.register("company--site-switcher", Company__SiteSwitcherController)

import Company__SessionCardController from "./company/session_card_controller"
application.register("company--session-card", Company__SessionCardController)

import Company__AppointmentReportController from "./company/appointment_report_controller"
application.register("company--appointment-report", Company__AppointmentReportController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TypedController from "./typed_controller"
application.register("typed", TypedController)

import Visitor__AccordionController from "./visitor/accordion_controller"
application.register("visitor--accordion", Visitor__AccordionController)

import Visitor__BookingCalendarController from "./visitor/booking_calendar_controller"
application.register("visitor--booking-calendar", Visitor__BookingCalendarController)

import Visitor__ConsentPreferencesController from "./visitor/consent_preferences_controller"
application.register("visitor--consent-preferences", Visitor__ConsentPreferencesController)

import Visitor__DocumentTitleController from "./visitor/document_title_controller"
application.register("visitor--document-title", Visitor__DocumentTitleController)

import Visitor__FaqSearchController from "./visitor/faq_search_controller"
application.register("visitor--faq-search", Visitor__FaqSearchController)

import Visitor__GoogleMapController from "./visitor/google_map_controller"
application.register("visitor--google-map", Visitor__GoogleMapController)

import Visitor__MarqueeController from "./visitor/marquee_controller"
application.register("visitor--marquee", Visitor__MarqueeController)

import Visitor__MutualInsuranceSearchController from "./visitor/mutual_insurance_search_controller"
application.register("visitor--mutual-insurance-search", Visitor__MutualInsuranceSearchController)

import Visitor__PractitionersMapController from "./visitor/practitioners_map_controller"
application.register("visitor--practitioners-map", Visitor__PractitionersMapController)

import Visitor__PractitionerSearchController from "./visitor/practitioner_search_controller"
application.register("visitor--practitioner-search", Visitor__PractitionerSearchController)

import Visitor__ReviewsListController from "./visitor/reviews_list_controller"
application.register("visitor--reviews-list", Visitor__ReviewsListController)

import Visitor__TableOfContentsController from "./visitor/table_of_contents_controller"
application.register("visitor--table-of-contents", Visitor__TableOfContentsController)

import WysiwygController from "./wysiwyg_controller"
application.register("wysiwyg", WysiwygController)

import FormChangeDetectorController from "./form_change_detector_controller"
application.register("form-change-detector", FormChangeDetectorController)

import Practitioner__CalendarTimeZoneController from "./practitioner/calendar_time_zone_controller"
application.register("practitioner--calendar-time-zone", Practitioner__CalendarTimeZoneController)

import Practitioner__PlanningController from "./practitioner/planning_controller"
application.register("practitioner--planning", Practitioner__PlanningController)

import Practitioner__WeeklyAvailabilitiesController from "./practitioner/weekly_availabilities_controller"
application.register("practitioner--weekly-availabilities", Practitioner__WeeklyAvailabilitiesController)

import Practitioner__AgendaController from "./practitioner/agenda_controller"
application.register("practitioner--agenda", Practitioner__AgendaController)

import Tabs__FrameController from "./tabs/frame_controller"
application.register("tabs--frame", Tabs__FrameController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import RecaptchaController from "./recaptcha_controller"
application.register("recaptcha", RecaptchaController)

import ReviewWizardController from "./review_wizard_controller"
application.register("review-wizard", ReviewWizardController)

import Admin__PageAlertController from "./admin/page_alert_controller"
application.register("admin--page-alert", Admin__PageAlertController)

import Admin__InvoiceItemsController from "./admin/invoice_items_controller"
application.register("admin--invoice-items", Admin__InvoiceItemsController)

import Admin__QuickSearchController from "./admin/quick_search_controller"
application.register("admin--quick-search", Admin__QuickSearchController)

import Admin__SidebarController from "./admin/sidebar_controller"
application.register("admin--sidebar", Admin__SidebarController)

import Admin__SiteFormController from "./admin/site_form_controller"
application.register("admin--site-form", Admin__SiteFormController)

import Admin__CompanyAppointmentFormController from "./admin/company_appointment_form_controller"
application.register("admin--company-appointment-form", Admin__CompanyAppointmentFormController)

import Admin__PostAuthorFormController from "./admin/post_author_form_controller"
application.register("admin--post-author-form", Admin__PostAuthorFormController)

import Admin__ZoneMapController from "./admin/zone_map_controller"
application.register("admin--zone-map", Admin__ZoneMapController)

import Admin__FieldHistoryController from "./admin/field_history_controller"
application.register("admin--field-history", Admin__FieldHistoryController)

import Admin__ZoneFormController from "./admin/zone_form_controller"
application.register("admin--zone-form", Admin__ZoneFormController)

import Admin__SectorMapController from "./admin/sector_map_controller"
application.register("admin--sector-map", Admin__SectorMapController)

import Admin__StaffMessageComposerController from "./admin/staff_message_composer_controller"
application.register("admin--staff-message-composer", Admin__StaffMessageComposerController)

import Admin__DictationController from "./admin/dictation_controller"
application.register("admin--dictation", Admin__DictationController)

import Admin__StaffMessageMentionsController from "./admin/staff_message_mentions_controller"
application.register("admin--staff-message-mentions", Admin__StaffMessageMentionsController)

import Admin__OutlineComparisonController from "./admin/outline_comparison_controller"
application.register("admin--outline-comparison", Admin__OutlineComparisonController)

import Form__PasswordVisibilityController from "./form/password_visibility_controller"
application.register("form--password-visibility", Form__PasswordVisibilityController)

